"use strict";

exports.__esModule = true;
exports.default = void 0;

var identity = function identity(x) {
  return x;
};

var _default = identity;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/utils/identity.js
// module id = ./node_modules/bootstrap-vue/es/utils/identity.js
// module chunks = 0 1 3 4